const AUTH_LOCAL_STORAGE_KEYS = [
  'user',
  'oldUser',
  'aria_chat_drafts',
  'api-rate-limit-until',
  'platformContext',
] as const;

const AUTH_SESSION_STORAGE_KEYS = [
  'aiTermsServiceRetryAttempt',
  'serviceInterruptionRetryAttempt',
] as const;

export const clearUserSession = () => {
  AUTH_LOCAL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  AUTH_SESSION_STORAGE_KEYS.forEach((key) => sessionStorage.removeItem(key));
};